import { FunctionComponent, PropsWithChildren } from 'react';

interface RegistrationWizardPageDescriptionProps extends PropsWithChildren {}

export const RegistrationWizardPageDescription: FunctionComponent<RegistrationWizardPageDescriptionProps> = ({ children }) => {
  return <div className="  mt-4 text-primary-950 ">{children}</div>;
};
